import { VinoDataSKU } from "../../types/vino-data-types";
import { isSingleVinoDataWineSKU } from "./sku";

export const bottleShapeFromVinoDataSKU = (
  sku: VinoDataSKU
): string | undefined => {
  if (!sku) return undefined;

  const [wine] = sku.wines;

  return isSingleVinoDataWineSKU(sku) && wine ? wine.bottleShape : undefined;
};
